import React from 'react';

import { Helmet } from 'react-helmet-async';

import { AboutCtaSection } from './about-cta-section';
import { AboutFeaturesSection } from './about-features-section';
import { AboutHowItWorksSection } from './about-how-it-works-section';
import { AboutMainSection } from './about-main-section';
import { AboutOurServicesSection } from './about-our-services-section';
import { AboutStatsSection } from './about-stats-section';
import { StyledAboutPage } from './styles';
import sectionBg from '../../theme/assets/backgrounds/bg-3-irregular.png';
import { bemClassName } from '../../utils/bem';
import { canonical, ogImage, ogUrl } from '../../utils/seo';
import { organizationSchema } from '../../utils/seo-schemas';

const b = bemClassName('about-page');

const AboutPage = () => {
  return (
    <StyledAboutPage $sectionBg={sectionBg}>
      <Helmet>
        <title>About Us — Your AI Health & Fitness Partner | Active Shape</title>
        <meta
          name="description"
          content="Learn about Active Shape — the AI-powered health platform helping you reach your nutrition and fitness goals with personalized plans, smart tracking, and data-driven insights."
        />
        {canonical('/about') && <link rel="canonical" href={canonical('/about')} />}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="About Us — Your AI Health & Fitness Partner | Active Shape" />
        <meta
          property="og:description"
          content="Learn about Active Shape — the AI-powered health platform helping you reach your nutrition and fitness goals with personalized plans, smart tracking, and data-driven insights."
        />
        {ogImage() && <meta property="og:image" content={ogImage()} />}
        {ogUrl('/about') && <meta property="og:url" content={ogUrl('/about')} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us — Your AI Health & Fitness Partner | Active Shape" />
        <meta
          name="twitter:description"
          content="Learn about Active Shape — the AI-powered health platform helping you reach your nutrition and fitness goals with personalized plans, smart tracking, and data-driven insights."
        />
        {ogImage() && <meta name="twitter:image" content={ogImage()} />}
        <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
      </Helmet>
      <div className={b()}>
        <div className={b('main-section')}>
          <AboutMainSection />
        </div>
        <div className={b('our-services-section')}>
          <AboutOurServicesSection />
        </div>
        <div className={b('features-section')}>
          <AboutFeaturesSection />
        </div>
        <div className={b('how-it-works-section')}>
          <AboutHowItWorksSection />
        </div>
        <div className={b('stats-section')}>
          <AboutStatsSection />
        </div>
        <div className={b('cta-section')}>
          <AboutCtaSection />
        </div>
      </div>
    </StyledAboutPage>
  );
};

export default AboutPage;
